__turbopack_context__.v({
  "body_rich_text": "BlogCTA-module-scss-module__L7K28q__body_rich_text",
  "direction__column": "BlogCTA-module-scss-module__L7K28q__direction__column",
  "direction__row": "BlogCTA-module-scss-module__L7K28q__direction__row",
  "gradient-glow-blue": "BlogCTA-module-scss-module__L7K28q__gradient-glow-blue",
  "gradient-glow-neon": "BlogCTA-module-scss-module__L7K28q__gradient-glow-neon",
  "gradient-glow-orange": "BlogCTA-module-scss-module__L7K28q__gradient-glow-orange",
  "gradient-glow-pink": "BlogCTA-module-scss-module__L7K28q__gradient-glow-pink",
  "gradient-glow-snap-pea": "BlogCTA-module-scss-module__L7K28q__gradient-glow-snap-pea",
  "gradient-neon-pink": "BlogCTA-module-scss-module__L7K28q__gradient-neon-pink",
  "gradient-pink-blue": "BlogCTA-module-scss-module__L7K28q__gradient-pink-blue",
  "gradient-pink-orange": "BlogCTA-module-scss-module__L7K28q__gradient-pink-orange",
  "layout__content-leading": "BlogCTA-module-scss-module__L7K28q__layout__content-leading",
  "layout__content-trailing": "BlogCTA-module-scss-module__L7K28q__layout__content-trailing",
  "module-base": "BlogCTA-module-scss-module__L7K28q__module-base",
  "module-content-swap": "BlogCTA-module-scss-module__L7K28q__module-content-swap",
  "module_block__contained": "BlogCTA-module-scss-module__L7K28q__module_block__contained",
  "module_block__uncontained": "BlogCTA-module-scss-module__L7K28q__module_block__uncontained",
  "module_breadcrumbs": "BlogCTA-module-scss-module__L7K28q__module_breadcrumbs",
  "section_bg_fill__base": "BlogCTA-module-scss-module__L7K28q__section_bg_fill__base",
  "section_bg_fill__gradient": "BlogCTA-module-scss-module__L7K28q__section_bg_fill__gradient",
  "section_bg_fill__no-fill": "BlogCTA-module-scss-module__L7K28q__section_bg_fill__no-fill",
  "section_bg_fill__raised": "BlogCTA-module-scss-module__L7K28q__section_bg_fill__raised",
  "section_container": "BlogCTA-module-scss-module__L7K28q__section_container",
  "with_breadcrumb": "BlogCTA-module-scss-module__L7K28q__with_breadcrumb",
  "with_navbar": "BlogCTA-module-scss-module__L7K28q__with_navbar",
});
